<template>
  <div class="settlement-detail">
    <div class="title-name">提现记录</div>
    <div class="select-date">
      <span>选择日期</span>
      <div class="date-wrap">
        <div class="select-box">
          <div @click="openDataPickerFn(0)" class="date-box">
            {{ withdrawTime[0] | regroupDate }}
          </div>
          <span class="desc">—</span>
          <div @click="openDataPickerFn(1)" class="date-box">
            {{ withdrawTime[1] | regroupDate }}
          </div>
        </div>
      </div>
    </div>
    <div class="money-type">
      <div class="name">货币类型</div>
      <div
        :class="[item.value === moneyType ? 'active item' : 'item']"
        v-for="(item, index) in moneyTypeArr"
        :key="index"
        @click="changeMoney(item)"
      >
        {{ item.text }}
      </div>
    </div>
    <NoData v-if="!detailArr.length"></NoData>
    <div class="data-wrap" v-else>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div
            class="item"
            v-for="(item, index) in detailArr"
            :key="index"
            @click="navToDetail(item)"
          >
            <div class="top">
              <div class="name">
                {{ item.id }}
              </div>
              <div class="money">{{ item.money | formatMoney }}</div>
            </div>
            <div class="bottom">
              <div class="time">{{ item.create_time | regroupDateNew }}</div>
              <div class="state">{{ item.state | regroupState }}</div>
            </div>
          </div>
          <div class="complete-tip" v-if="detailArr.length >= tableInfo.total">
            到底啦！
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- <van-popup v-model="isShowTypePicker" position="bottom">
      <van-picker
        value-key="name"
        :columns="moneyTypeArr"
        @change="onConfirmType"
      />
    </van-popup> -->
    <van-popup v-model="isShowDataPicker" position="bottom">
      <van-datetime-picker
        active-class="active-date"
        v-model="currentDate"
        type="date"
        confirm-button-text="完成"
        :title="datePickerTitle"
        :max-date="maxDate"
        @confirm="confirmDateFn"
        @cancel="isShowDataPicker = false"
      />
    </van-popup>
    <!-- <Pagination
      :tableInfo="tableInfo"
      @changCurrentPage="changCurrentPage"
    ></Pagination> -->
  </div>
</template>

<script>
import { getRecordList } from '@/api/income';
import NoData from '@/components/NoData.vue';
import numeral from 'numeral';
// import Pagination from './components/pagination';
export default {
  components: {
    // Pagination,
    NoData
  },
  data() {
    return {
      moneyType: 999,
      isShowTypePicker: false,
      isShowDataPicker: false,
      moneyTypeArr: [
        { value: 999, text: '全部' },
        { value: 1, text: '现金' },
        { value: 2, text: '迷你豆' },
      ],
      minDate: new Date(new Date() - 3600 * 1000 * 24 * 365),
      maxDate: new Date(new Date()),
      datePickerTitle: '开始时间',
      currentDate: '',
      loading: false,
      finished: false,
      refreshing: false, //下拉刷新
      dateInputNum: 0, // 记录当前是开始/结束
      withdrawTime: [
        new Date(new Date() - 3600 * 1000 * 24 * 30),
        new Date(new Date()),
      ],
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      detailArr: [],
      showDefaultImg: false,
    };
  },
  filters: {
    formatMoney(val) {
      return numeral(val).format('0,0.00');
    },
    regroupType(val) {
      let txt = '';
      switch (val) {
        case 999:
          txt = '全部';
          break;
        case 1:
          txt = '现金';
          break;
        case 2:
          txt = '迷你豆';
          break;
        default:
          break;
      }
      return txt;
    },
    regroupDate(val) {
      let time = new Date(val);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    regroupDateNew(val) {
      let time = new Date(val * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '' + month + '' + date;
    },
    regroupState(val) {
      let stateTxt = '';
      switch (val) {
        case 1:
          stateTxt = '发起提现';
          break;
        case 2:
          stateTxt = '邮寄发票';
          break;
        case 3:
          stateTxt = '签收发票';
          break;
        case 4:
          stateTxt = '发票审核通过';
          break;
        case 5:
          stateTxt = '发票审核失败';
          break;
        case 6:
          stateTxt = '打款成功';
          break;
        case 7:
          stateTxt = '订单关闭';
          break;
        case 8:
          stateTxt = '打款完成';
          break;
        default:
          break;
      }
      return stateTxt;
    },
    regroupAcc(val) {
      if (val) {
        if (typeof val == 'number') {
          return `迷你豆提现_游戏账号（${val}）`;
        } else {
          let reg1 = /[\u4e00-\u9fa5]{2,}/gi;
          let reg2 = /(\d{1,3})+(?:\.\d+)?/gi;
          let txt1 = val.replace(reg2, '');
          let txt2 = val.replace(reg1, '');
          let res = `钱包提现_${txt1}（${txt2.substring(txt2.length - 4)} ）`;
          return res;
        }
      }
    },
  },
  mounted() {
    this.withdrawShow();
  },
  created() {
    this.fetchRecordList();
  },
  methods: {
    //提现记录页曝光埋点
    withdrawShow() {
      this.$log('withdrawa_record_show', 85435, { v7: 2 });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    //跳转到提现详情
    navToDetail(item) {
      this.$router.push({
        path: '/income/withdrawDetail',
        query: { id: item.id },
      });
    },
    onLoad() {
      this.tableInfo.page = this.tableInfo.page + 1;
      this.fetchRecordList();
    },
    async fetchRecordList() {
      let time = [
        new Date(this.withdrawTime[0].toDateString()).getTime() / 1000,
        new Date(this.withdrawTime[1].toDateString()).getTime() / 1000 +
          24 * 60 * 60 -
          1,
      ];
      try {
        this.loading = true;
        let body = {
          money_type: this.moneyType,
          start_time: time[0],
          end_time: time[1],
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
          dtype: 1,
        };
        const res = await getRecordList(body);
        if (res.data.list.length) {
          let list = res.data.list;
          this.detailArr = this.detailArr.concat(list);
          this.refreshing = false;
          this.loading = false;
          this.tableInfo.total = res.data.total_count;
          if (this.detailArr.length >= this.tableInfo.total)
            this.finished = true; //表示加载完成
        }
        console.log(this.detailArr.length, 'length');
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 打开选择时间
    openDataPickerFn(index) {
      this.dateInputNum = index;
      index
        ? (this.datePickerTitle = '结束时间')
        : (this.datePickerTitle = '开始时间');
      this.currentDate = this.withdrawTime[index];
      this.isShowDataPicker = true;
    },
    // 确认选择时间
    confirmDateFn(date) {
      let timeArr = [];
      if (this.dateInputNum) {
        timeArr[1] = date;
        timeArr[0] = this.withdrawTime[0].getTime();
      } else {
        timeArr[0] = date;
        timeArr[1] = this.withdrawTime[1].getTime();
      }
      if (timeArr[0] > timeArr[1]) {
        this.$Toast('结束日期不能在开始日期之前');
      } else {
        this.withdrawTime[this.dateInputNum] = date;
        this.isShowDataPicker = false;
        this.detailArr = []; //清空数据
        this.fetchRecordList();
      }
    },
    changCurrentPage(page) {
      this.tableInfo.page = page;
      this.fetchRecordList();
    },
    queryTableFn() {
      this.tableInfo.page = 1;
      this.fetchRecordList();
    },
    changeMoney(item) {
      this.moneyType = item.value;
      this.detailArr = [];
      this.fetchRecordList();
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding: 0px 0px !important;
}
.settlement-detail {
  font-size: 24px;
  min-height: calc(100vh - 103px);
  .title-name {
    font-size: 36px;
    color: #000000;
    width: 156px;
    text-align: center;
    border-bottom: 4px solid#FD9B21;
    margin-bottom: 28px;
  }
  .filter-type {
    display: flex;
    align-items: center;
    margin: 30px 0;
    font-size: 28px;
    .drop-down {
      margin-left: 12px;
      width: 185px;
      height: 60px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      display: flex;
      align-items: center;
      font-size: 24px;
      justify-content: space-around;
      .arrows {
        width: 32px;
        height: 32px;
        transition: all 0.5s ease;
      }
      .arrows.close {
        transform: rotate(180deg);
      }
      .arrows.open {
        transform: rotate(0deg);
      }
    }
  }
  .select-date {
    font-size: 28px;
    display: flex;
    align-items: center;
    .date-wrap {
      flex: 1;
      height: 56px;
      margin-left: 5px;
      display: flex;
      justify-content: space-between;
      .select-box {
        flex: 1;
        display: flex;
        align-items: center;
        // justify-content: space-around;
        border-radius: 4px;
        padding-left: 10px;
        .date-box {
          width: 144px;
          height: 60px;
          background: #ffffff;
          border-radius: 4px;
          color: #262626;
          font-size: 24px;
          padding-top: 13px;
          text-align: center;
          border: 1px solid #d9d9d9;
        }
        .desc {
          margin: 0px 8px;
          color: #bfbfbf;
          font-size: 28px;
        }
      }
      .btn-query {
        width: 90px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background: #f5f5f5;
        border: 1px solid #d9d9d9;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        margin-left: -2px;
      }
    }
  }
  .detail-wrap {
    margin: 45px 0;
    border-bottom: 1px solid #d9d9d9;

    .detail-item {
      border-top: 1px solid #d9d9d9;
      height: 160px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 30px 0;
      .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .name-num {
        font-size: 26px;
      }
      .money-num {
        font-size: 36px;
      }
      .time-state {
        color: #81818f;
      }
    }
  }
  .img-loading {
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .data-wrap {
    margin-top: 32px;
    .item {
      width: 750px;
      height: 152px;
      background: #ffffff;
      border-bottom: 2px solid rgba(151, 151, 151, 0.39);
      padding: 40px 24px 30px 24px;
      .top {
        display: flex;
        .name {
          flex: 1;
          color: #262626;
          font-size: 28px;
        }
        .money {
          padding-right: 44px;
          font-weight: 500;
          color: #000000;
          font-size: 40px;
        }
      }
      .bottom {
        display: flex;
        color: #8c8c8c;
        font-size: 24px;
        .time {
          flex: 1;
        }
        .state {
          margin-right: 48px;
        }
      }
    }
    .complete-tip {
      font-size: 24px;
      color: #8c8c8c;
      text-align: center;
      margin-top: 10px;
    }
  }
}
.money-type {
  display: flex;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 32px;
  .name {
    color: #000000;
    font-size: 28px;
    margin-right: 11px;
  }
  .item {
     padding: 14px 16px;
    // padding: 14px 0;
    text-align: center;
    font-size: 24px;
    height: 60px;
    width: auto;
    background-color: #ffffff;
    border-radius: 4px;
    border-radius: 4px;
    margin-right: 14px;
    margin-left: 0;
  }
  .active.item {
    background: #fd9b21;
    color: #ffffffff;
  }
}
</style>
